// extracted by mini-css-extract-plugin
export default {"tooltip":"UV-z","arrow":"VV-z"};